<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { MenuItem } from '@/presentation/components/mainmenu/MenuItem.ts';

const { t } = useI18n();
defineProps<{
  item: MenuItem;
  collapsed: boolean;
}>();
</script>

<template>
  <li
    class="group relative flex items-center px-2 py-2 m-2 hover:bg-gray-800 hover:rounded-md cursor-pointer select-none"
    @click="item.clickClosure()"
  >
    <div class="w-6 flex justify-center">
      <font-awesome-icon v-if="!$slots.icon" class="fa-fw text-lg" :icon="item.icon" />
      <slot name="icon"/>
    </div>
    <span
      class="whitespace-nowrap overflow-hidden transition-[width,opacity] duration-300 ml-2"
      :style="{ width: collapsed ? '0px' : '140px', opacity: collapsed ? 0 : 1 }"
    >
      {{ t(item.translation?.key, item.translation?.params) }}
    </span>
  </li>
</template>
